import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getHasSigningError,
  getHasVideoBucketUploadFailed,
  getPresignedError,
  getBucketUploadError
} from '../../redux/modules/campaignLandingPage';
import styles from './UploadError.module.less';

const UploadError = ({ hasSigningError, hasUploadFailure, presignedError, bucketError }) => {
  if (!hasSigningError && !hasUploadFailure) {
    return null;
  }

  const errorMessage =
    bucketError ||
    presignedError ||
    'Upload failed. You may retry your upload or download your video and try again later';

  return <div className={styles.vpUploadError}>{errorMessage}</div>;
};

UploadError.propTypes = {
  hasSigningError: PropTypes.bool,
  hasUploadFailure: PropTypes.bool,
  presignedError: PropTypes.string,
  bucketError: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  return {
    hasSigningError: getHasSigningError(state, ownProps.qid),
    hasUploadFailure: getHasVideoBucketUploadFailed(state, ownProps.qid),
    presignedError: getPresignedError(state, ownProps.qid),
    bucketError: getBucketUploadError(state, ownProps.qid)
  };
}

export default connect(mapStateToProps)(UploadError);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/UploadError.jsx